import { IFacetMapping } from '../../models/Facet';
import { IItemCacheThunkAction, IItemCacheDispatch } from '../../store/actions/ItemCacheActions';
import { readItem } from '../readItem';
import { configurationItemKey } from '../../facets/ConfigurationFacets';

/**
 * Creates an action which, when dispatched, reads the specified configuration facets from the store.
 * Use this action creator to obtain store configuration within a dispatched operation.
 *
 * @public
 */
export function readConfiguration<TFacets extends object>(mapping: IFacetMapping<TFacets>): IItemCacheThunkAction<Partial<TFacets>> {
  return (dispatch: IItemCacheDispatch) => {
    return dispatch(readItem(mapping, configurationItemKey));
  };
}
